export default __webpack_public_path__ + "b107e28b1b27fb2b5d3bde3ed823ff38.svg";